import * as React from 'react';

import {withStyles, WithStyles} from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import {LandingStyle} from "./landing.style";
import SelectLanguage from "@components/common/language/SelectLanguage";
import Button from "@components/common/button/Button";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import {Typography} from "@material-ui/core";
import CornerRightElements from "@components/svg/cornerRightElements";
import CornerLeftElements from "@components/svg/cornerLeftElements";
import {BreakpointProvider} from "@utils";
import { Link } from 'react-router-dom';

const tn: TranslateNew = TranslateNew.getInstance();

class Landing extends React.Component<WithStyles<typeof LandingStyle>> {

    public render() {
        const style = this.props.classes;

        return (<div className={style.root}>
            <div className={style.background}>
                <BreakpointProvider>
                    {(isDesktop: boolean) => (
                        <>
                            <CornerLeftElements viewBox={isDesktop ? "0 -28 259 220" : "19 -28 259 220"}
                                                className={style.backgroundImgCornerBottomLeft}/>
                            <CornerRightElements viewBox="-29 8 247 278" className={style.backgroundImgCornerTopRight}/>
                        </>
                    )}
                </BreakpointProvider>
            </div>
            <div className={style.languageSelect}>
                <SelectLanguage/>
            </div>
            <div className={style.container}>
                <div className={style.middleContent}>
                    <Typography variant="h1" align="center">{tn.lang.landingTitle}</Typography>
                </div>
                <div className={style.bottomContent}>
                    <Link to='/signup' style={{textDecoration: 'none'}}>
                        <Button
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}
                        >
                            <span style={{flex: 1}}>{tn.lang.landingImNewCreateAccount}</span>
                            <ArrowForwardIcon fontSize="small"/>
                        </Button>
                    </Link>
                    <Link to='/login' style={{textDecoration: 'none'}}>
                        <Button
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}>
                            <span style={{flex: 1}}>{tn.lang.logInButton}</span>
                            <ArrowForwardIcon fontSize="small"/>
                        </Button>
                    </Link>
                </div>
            </div>
        </div>);
    }
}


export default withStyles(LandingStyle)(Landing);



// WEBPACK FOOTER //
// ./src/components/landing/landing.component.tsx